
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/EEAT",
      function () {
        return require("private-next-pages/EEAT.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/EEAT"])
      });
    }
  